"use client";

import React from "react";
import Marquee from "react-fast-marquee";
import Image from "next/image";
import Link from "next/link";
import { faBolt, FontAwesomeIcon } from "@/constants/icons";

interface MerchantItem {
    name: string;
    logo: string;
    href: string;
    discount_tag?: string;
}

interface Props {
    merchants: MerchantItem[];
}

const MerchantMarquee = ({ merchants }: Props) => {
    const items = [...merchants, ...merchants];

    return (
        <Marquee
            speed={38}
            pauseOnHover
            gradient={false}
            className="overflow-hidden"
        >
            {items.map((merchant, i) => (
                <Link
                    key={i}
                    href={merchant.href}
                    className="group flex flex-col items-center mx-2 w-[150px] shrink-0"
                >
                    <div className="relative flex flex-col items-center w-full px-3 pt-4 pb-3 bg-white/10 hover:bg-white rounded-2xl border border-white/15 hover:border-transparent transition-all duration-300 hover:shadow-[0_8px_20px_-4px_rgba(0,0,0,0.3)]">

                        {/* Logo — larger, less bottom gap */}
                        <div className="relative w-16 h-16 rounded-xl bg-white flex items-center justify-center overflow-hidden shadow-sm group-hover:scale-105 transition-transform duration-300 shrink-0 mb-2">
                            <Image
                                src={merchant.logo}
                                alt={merchant.name}
                                fill
                                className="object-contain p-2"
                                unoptimized
                            />
                        </div>

                        {/* Name — tight spacing below logo */}
                        <p className="text-[10px] font-black text-white group-hover:text-[#D61C4E] uppercase tracking-wide text-center truncate w-full transition-colors leading-tight mb-1.5">
                            {merchant.name}
                        </p>

                        {/* Discount badge or spacer */}
                        {merchant.discount_tag ? (
                            <div className="flex items-center gap-1 bg-white/20 group-hover:bg-[#D61C4E] px-2 py-0.5 rounded-full transition-colors duration-300">
                                <FontAwesomeIcon icon={faBolt} className="w-2 h-2 text-white" />
                                <span className="text-[9px] font-black text-white uppercase tracking-wide">
                                    {merchant.discount_tag}
                                </span>
                            </div>
                        ) : (
                            <div className="h-[18px]" />
                        )}
                    </div>
                </Link>
            ))}
        </Marquee>
    );
};

export default MerchantMarquee;
